class Storage {
    storeName = '';
    id = '';
    key = 'oms_';
    oldKey = '';
    mode = '';//old//
    hasOldKey = false;

    constructor() {
    }

    /**
     * Key of store
     *  
     */
    setKey() {
        // this.oldKey = this.storeName + this.id;
        // this.key = this.key + this.storeName + this.id;
        this.key = (this.hasOldKey) ? this.storeName + this.id : this.key + this.storeName + this.id;
    }

    /**
     * Set a value to localStorage.
     * 
     * @param {string} id id for storage
     * @param {any} data data to store
     * @returns {string} return the "Set + [key]" if value is set or return "Not supported" message if it's failed to set.
     */
    setData(data) {
        let returnData;

        if (window.localStorage) {
            let key = this.key;
            // let value = this.formatSetData(data);

            // // localStorage.setItem(key, value.new_format);//new
            // // localStorage.setItem(this.oldKey, value.old_format);//old
            // localStorage.setItem(key, value);
            let value = null;
            if(this.hasOldKey) {
                value = this.formatSetDataOld(data);
            } else {
                value = this.formatSetData(data);
            }
            localStorage.setItem(key, value);

            returnData = "Set " + key;
        } else {
            returnData = "LocalStorage not supprted.";
        }

        return returnData;
    }

    /**
     * Get data from storage
     * 
     * @returns {(string|Object)} The value of given key
     */
    getData() {
        let data = null;
        // let key = (this.mode === 'old') ? this.oldKey : this.key;//
        let key = this.key;

        if ((localStorage.getItem(key)) && (localStorage.getItem(key) != 'undefined')) {
            data = localStorage.getItem(key);
            data = this.formatGetData(data);
        }

        return data;
    }

    /**
     * Remove data from storage
     * 
     * @returns {bool} return true for success calls.
     */

    removeData() {
        let key = this.key;

        if (window.localStorage) {
            localStorage.removeItem(key);//new
            // localStorage.removeItem(this.oldKey);//old key
        }

        return true;
    }

    // /**
    //  * Format data for store
    //  * 
    //  * @param {*} data data to store
    //  * @returns 
    //  */
    // formatSetData(data) {
    //     // let returnData = JSON.stringify({ 'data': data, 'timestamp': new Date().getTime() });

    //     let authType = null,
    //         dataSet = null,
    //         success = false,
    //         message = '',
    //         timestamp = new Date().getTime(),
    //         total = 0;

    //     if (data.data.success) {
    //         success = data.data.success;
    //         authType = (data.authType) ? data.authType : null;
    //         dataSet = (data.data.data) ? data.data.data : null;
    //         message = (data.data.message) ? data.data.message : '';
    //         total = (data.data.total) ? data.data.total : 0;
    //     }

    //     let returnData = {
    //         'old_format': JSON.stringify({
    //             'data': data.data,
    //             'timestamp': timestamp
    //         }),
    //         'new_format': JSON.stringify({
    //             'success': success,
    //             'message': message,
    //             'total' : total,
    //             'authType': authType,
    //             'data': dataSet,
    //             'timestamp': timestamp
    //         })
    //     };
    //     return returnData;
    // }

    /**
     * Format data for store
     * 
     * @param {*} data data to store
     * @returns 
     */
     formatSetData(data) {
        // let returnData = JSON.stringify({ 'data': data, 'timestamp': new Date().getTime() });

        let authType = null,
            dataSet = null,
            success = false,
            message = '',
            timestamp = new Date().getTime(),
            total = 0;

        if (data.data.success) {
            success = data.data.success;
            authType = (data.authType) ? data.authType : null;
            dataSet = (data.data.data) ? data.data.data : null;
            message = (data.data.message) ? data.data.message : null;
            total = (data.data.total) ? data.data.total : null;
        }

        let returnData = JSON.stringify({
            'authType': authType,
            'success': success,
            'message': message,
            'total' : total,
            'data': dataSet,
            'timestamp': timestamp
        });
        return returnData;
    }

    /**
     * Format data for store
     * 
     * @param {*} data data to store
     * @returns 
     */
     formatSetDataOld(data) {
        // let returnData = JSON.stringify({ 'data': data, 'timestamp': new Date().getTime() });

        let timestamp = new Date().getTime();

        let returnData = JSON.stringify({
            'authType': (data.authType) ? data.authType : null,
            'data': data.data,
            'timestamp': timestamp
        });
        return returnData;
    }

    /**
     * Format data for get
     * 
     * @param {*} data data to store
     * @returns 
     */
    formatGetData(data) {
        let returnData = JSON.parse(data);
        return returnData;
    }

}

export default Storage;